import * as React from 'react';
/**
 * @hidden
 */
export var ListNoData = function (props) {
    return React.createElement("div", { className: "k-nodata" },
        React.createElement("div", null, props.children));
};
//# sourceMappingURL=ListNoData.js.map